import React from 'react';

export function NexusField({ label, full = false, children, hint }) {
  return (
    <div className={`call-field ${full ? 'full' : ''}`.trim()}>
      {label ? <label>{label}</label> : null}
      {children}
      {hint ? <div className="kanban-mini">{hint}</div> : null}
    </div>
  );
}

export function NexusInput({ label, full = false, hint, ...props }) {
  return (
    <NexusField label={label} full={full} hint={hint}>
      <input {...props} />
    </NexusField>
  );
}

export function NexusSelect({ label, full = false, hint, children, ...props }) {
  return (
    <NexusField label={label} full={full} hint={hint}>
      <select {...props}>{children}</select>
    </NexusField>
  );
}

export function NexusTextarea({ label, full = false, hint, ...props }) {
  return (
    <NexusField label={label} full={full} hint={hint}>
      <textarea {...props} />
    </NexusField>
  );
}
